import { ApiUtility } from "../../../Utilities/ApiUtility.axios";

export enum PriorityLevel {
  Low,
  Medium,
  High,
  Unspecified,
  All,
}

class RequisitionService {
  private route = "V1/API/Inv_Requisition/";

  postRequisition = (companyId: string, params: any, reqId?: string) => {
    return ApiUtility.post(
      `${this.route}${companyId}${reqId ? "/" + reqId : ""}`,
      params
    );
  };

  getRequisitionList = (
    companyId: string,
    search?: string,
    priority?: PriorityLevel,
    startDate?: Date,
    endDate?: Date
  ) =>
    ApiUtility.get(`${this.route}${companyId}/GetList`, {
      search,
      priority,
      startDate,
      endDate,
    });

  getRequisition = (companyId: string, reqId: string) =>
    ApiUtility.get(`${this.route}${companyId}/${reqId}`);

  deleteRequisition = (companyId: string, reqId: string) =>
    ApiUtility.delete(`${this.route}${companyId}/${reqId}`);
}

export default new RequisitionService();
